export interface Employee {
  id: string;
  employeeId: string;
  userId: string | null;
  departmentId: string | null;
  employeeType: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  designation: string;
  joiningDate: string | null;
  qualification: string | null;
  experience: number | null;
  emergencyContact: string | null;
  status: string;
  createdAt: string;
  updatedAt: string;
  
  // Relations
  user?: {
    id: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    phone: string | null;
  } | null;
  
  department?: {
    id: string;
    name: string;
    code: string;
  } | null;
}

export interface EmployeeFormData {
  employeeId: string;
  userId?: string;
  departmentId?: string;
  employeeType: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  designation: string;
  joiningDate?: string;
  qualification?: string;
  experience?: number;
  emergencyContact?: string;
  status: string;
}

export interface EmployeeFilterParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  employeeType?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface EmployeeListResponse {
  data: Employee[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const EMPLOYEE_TYPES = [
  { value: 'DOCTOR', label: 'Doctor' },
  { value: 'NURSE', label: 'Nurse' },
  { value: 'STAFF', label: 'Staff' },
  { value: 'ADMIN', label: 'Administrator' },
];

export const EMPLOYEE_STATUSES = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'ON_LEAVE', label: 'On Leave' },
  { value: 'TERMINATED', label: 'Terminated' },
];
